import { render, staticRenderFns } from "./CustomerPaymentReceiptFile.vue?vue&type=template&id=df7a24e6&scoped=true&"
import script from "./CustomerPaymentReceiptFile.vue?vue&type=script&lang=js&"
export * from "./CustomerPaymentReceiptFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7a24e6",
  null
  
)

export default component.exports